angular.module('TetherApp').factory('noteService', [
    '$http',
    function ($http) {
        let randomString = function () {
            let result = '';
            let length = 16;
            let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let listNotes = function (participantId) {
            let uri = '/api/v1/participants/' + participantId + '/notes/' + randomString();
            return $http.get(uri, {
                cache: false,
                headers: { 'Cache-Control': 'no-cache' }
            })
                .then(function (response) {
                    return response.data;
                });
        };

        return {
            listNotes: listNotes
        };
    }
]);
